import React, { useState } from 'react';
import { DatePicker } from '@mantine/dates';
import { ArrowDownIcon } from 'pageFramework/uiControls/icons';
import { Popover } from '@mantine/core';
import { Button } from 'pageFramework/uiControls/buttons';
export interface CalendarDatePickerProps {
	value: string | Date;
	defaultDate: string;
	onChange?: (value: any) => void;
	onTodayClick?: (value: any) => void;
	dateRangeLabel: string;
	view: string;
}

export const CalendarDatePicker: React.FC<CalendarDatePickerProps> = (props) => {
	const { value, onChange, dateRangeLabel, view, onTodayClick, defaultDate } = props;
	const [modalOpen, setModalOpen] = useState<boolean>(false);

	const handleDateChange = (val: any) => {
		if (onChange) {
			onChange(val);
		}
		setModalOpen(false);
	};

	const handleTodayClick = (val: any) => {
		setModalOpen(false);
		if (onTodayClick) {
			onTodayClick(val);
		}
	};

	return (
		<div>
			<Popover trapFocus position="bottom" withArrow shadow="md" opened={modalOpen} onChange={setModalOpen}>
				{view === "week" &&
					<Popover.Target>
						<div className="current-scope-heading weekViewDate" onClick={() => setModalOpen(!modalOpen)}>{dateRangeLabel} <ArrowDownIcon /></div>
					</Popover.Target>
				}
				{view === "day" &&
					<Popover.Target>
						<div className="current-scope-heading dayViewDate" onClick={() => setModalOpen(!modalOpen)}>{dateRangeLabel} <ArrowDownIcon /></div>
					</Popover.Target>
				}
				<Popover.Dropdown>
					<DatePicker onChange={handleDateChange} value={value} defaultDate={defaultDate}></DatePicker>
					<Button color="secondary" variant="outline" onClick={handleTodayClick}>Today</Button>
				</Popover.Dropdown>
			</Popover>
		</div>
	);
};
